import "../instrument"
import { createRoot } from "react-dom/client"
import * as Sentry from "@sentry/react"
import App from "~/root/app"

const rootEl = document.getElementById("react-root")
if (rootEl) {
  const root = createRoot(rootEl)
  root.render(
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
      <App />
    </Sentry.ErrorBoundary>
  )
} else {
  console.error("no react-root")
}
